import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as SearchWhiteIcon } from '../../../assets/graphics/svg/colorable/cloud_icon_search_white.svg';
import { TextInput, TextInputProps } from '../TextInput';
import './SearchBar.css';

export type SearchBarProps = TextInputProps & {
  onSearch: () => void;
  backgroundColor?: string;
};

export const SearchBar = memo(
  ({
    value,
    onChange,
    placeholder,
    onSearch,
    backgroundColor = '#f1f1f1',
  }: SearchBarProps) => {
    const { t } = useTranslation();
    return (
      <div className={'search-bar'}>
        <TextInput
          value={value}
          onChange={onChange}
          placeholder={placeholder ?? t('Search')}
          style={{
            borderRadius: '8px 0 0 8px',
            margin: 0,
            width: '100%',
            height: '38px',
            color: '#000',
            padding: '0 46px 0 16px',
            backgroundColor: backgroundColor,
          }}
        />

        <div className="search-button-container" onClick={onSearch}>
          <SearchWhiteIcon
            className="search-icon"
            stroke={'#ffffff'}
            fill={'#ffffff'}
          />
        </div>
      </div>
    );
  },
);
